<template>
    <div class="chooseRole-content page-main pad-20">
        <!--审核/撤回弹出框-->
        <el-dialog title="角色切换" :visible.sync="chooseRoleDiag" width="660px" style="height: auto;" class="chooseRoleDiag-content" :before-close="closeDiag">
<!--            <div class="roleList-content">-->
<!--                <div class="list-content" v-for="item in roleList" @click="chooseRole(item)">-->
<!--                    <div class="list-left">-->
<!--                        <span>{{item.role_name.charAt(0)}}</span>-->
<!--                    </div>-->
<!--                    <div class="list-right">-->
<!--                        <p class="p-name">{{item.role_name}}</p>-->
<!--                        <p class="p-type">{{item.role_type_name}}</p>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="roleList-content1">
                <div class="chooseRole-list commonBorderHover" v-for="item in roleList" @click="chooseRole(item)" :class="{'commonBorder':chooseRoleData == item.role_id}">
                    <div class="role-text">
                        <span class="span1">{{item.name}}</span>
                        <span class="span2 commonBgColorOp commonTextColor">{{item.role_name}}</span>
                    </div>
                    <el-checkbox v-model="chooseRoleData == item.role_id"></el-checkbox>
                </div>
            </div>
<!--            <div class="btn-content" v-if="isRoleData">-->
<!--                <el-button type="primary" size="small">确认</el-button>-->
<!--                <el-button size="small" @click="closeDiag('close')">取消</el-button>-->
<!--            </div>-->
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import {showTip,getSessionData,setSessionData} from "@/utils/commonApi";
import {getUser_role} from "@/api/roleModel/roleApi";
import {deleteSessionData} from "../../utils/commonApi";
export default {
    components: {},
    data() {
        return {
            chooseRoleDiag:false, //弹出框
            isRoleData:false, //是否选择过角色
            roleList:[], //角色列表
            chooseRoleData:"1",
        };
    },
    props:["roleType"],
    computed: {},
    created() {
        this.isRoleData = getSessionData("roleData");
    },
    filters: {},
    watch: {
        roleType(newVal, oldVal) {
            console.log(newVal)
            if(newVal == "change"){
                this.chooseRoleDiag = true;
                this.getRole()
            }
        }
    },
    activated() {
    },
    mounted(){
        let $this = this
        console.log(this.roleType)
        $this.init();
},
    methods: {
        /*初始化*/
        init(){
            if(this.roleType == "first"||this.roleType == "change"){
                this.chooseRoleDiag = true;
                if(!getSessionData("roleData")){
                    this.getRole()
                }
            }
        },
        /*获取角色列表*/
        getRole(){
            let $this = this;
            getUser_role().then((res) => {
                if(res.code == "SUCCESS"){
                    $this.roleList = res.data;
                    if(getSessionData("roleData")){
                        $this.chooseRoleData = getSessionData("roleData").role_id;
                    }
                }else{
                    showTip("获取数据失败","warning")
                }
            })
        },
        /*选择角色*/
        chooseRole(item){
            let $this = this;
            deleteSessionData("menuInfo");
            deleteSessionData("loginUserInfo");
            setSessionData("roleData",item);
            location.href = "/";
        },
        /*关闭弹框*/
        closeDiag(done){
            if(!this.isRoleData){
                showTip("请选择角色","warning","show")
            }else{
                this.$emit("closeChooseRoleDiag");
                done=="close"?this.chooseRoleDiag = false:done();
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
.chooseRole-content{

    .roleList-content{
        display:flex;
        flex-wrap:wrap;
        // border: 1px solid #000;
        .list-content{
            padding:16px;
            border:1px solid #409EFF;
            border-radius:6px;
            cursor:pointer;
            margin:10px;
            display:flex;
            align-items:center;
            min-width:300px;
            max-width:300px;
            .list-left{
                background-color:#409EFF;
                display inline-block
                min-width 42px
                max-height 42px
                border-radius 50%
                text-align center
                line-height 42px;
                color #FFF
                span{
                    font-size 20px
                }
            }
            .list-right{
                margin-left 16px
                p{
                    line-height 1.8
                }
                .p-name{
                    color #333
                    font-size 16px
                    width:210px;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    // border: 1px solid #000;
                }
                .p-type{
                    color #999
                    font-size 16px
                }
            }
            &:hover {
               border 2px solid #409EFF
            }

        }
    }
    .roleList-content1{
        display:flex;
        flex-direction:column;
        .chooseRole-list{
            display:flex;
            justify-content:space-between;
            padding:30px 20px;
            align-items:center;
            border-radius: 8px;
            border: 1px solid #CBCBCB;
            cursor:pointer;
            margin-bottom:20px;
            .role-text{
                .span1{
                    font-size:18px;
                    color:#333;
                }
                .span2{
                    display:inline-block;
                    height:24px;
                    padding:0 12px;
                    line-height:24px;
                    border-radius:12px;
                    font-size:16px;
                    margin-left:16px;
                }
            }
        }
    }
    .btn-content{
        text-align: right;
    }
}
</style>
<style lang="stylus">

.chooseRole-content{

}
.chooseRoleDiag-content{
    .el-checkbox__inner{
        border-radius:50%;
        width:18px;
        height:18px;
    }
    .el-checkbox__inner::after{
        left:6px;
        height:10px;
    }
    .el-radio__label {
        display: none; /* 隐藏文本 */
    }
  .el-dialog__header{
    display: block !important;
  }
  .el-dialog{
    height: auto !important;
  }

}
</style>
